var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-page',{attrs:{"fluid":"lg","name":"profile"}},[_c('b-row',[_c('b-col',{attrs:{"md":"3"}},[_c('profile-sidebar')],1),_c('b-col',{style:({ 'view-transition-name': 'content' }),attrs:{"md":"9"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }